// extracted by mini-css-extract-plugin
module.exports = {"subrnd3":"subrnd3_subrnd3__274_b","back-btn":"subrnd3_back-btn__9iAUm","subrnd3-img1":"subrnd3_subrnd3-img1__2tTlJ","subrnd3-img2":"subrnd3_subrnd3-img2__1Qgg4"};